<template>
  <Channel />
  <Statistical />
  <a-config-provider :locale="expand.locale">
    <div id="index" class="index">
      <div class="container">
        <Main v-if="$route.path==='/'" />
        <router-view v-else />
      </div>
    </div>
  </a-config-provider>
</template>

<script lang="ts" type="text/tsx">
import AntDesign from 'ant-design-vue';
import Locale from 'ant-design-vue/lib/locale-provider/zh_CN';

import { DataInterface } from '@interface/public';
import Channel from '@template/_component/channel.vue';
import Statistical from '@template/_component/statistical.vue';
import Main from '@template/_component/main.vue';

export default {
  name: 'index',
  components: {
    Channel,
    Statistical,
    Main
  },
  data(): DataInterface {
    return {
      expand: {
        locale: Locale
      }
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        $Store.Public().$patch({
          router: newData.path
        });
        
        $RQ.PushWebHookPrometheus({
          action: $Enum.PrometheusActionEnum.View,
          bdata: { ic: $Store.User().invite }
        });
      }
    }
  },
  beforeCreate(): void {
    $Application.Main.use(AntDesign);
  },
  mounted(): void {
    $Store.User().filterLink();
    this.resize();
  },
  methods: {
    /**
     * 改变Rem
     */
    changeRem(): void {
      const width = $Store.Public().width;
      let fontSize = width / $Enum.GridEnum.Mobile * 100;
      
      // width >= $Enum.GridEnum.PC && (fontSize = 75);
      fontSize > 100 && (fontSize = 100);
      document.documentElement.style.fontSize = `${ fontSize }px`;
    },
    
    /**
     * 改变尺寸
     */
    resize(): void {
      $FN.Resize(() => {
        $Store.Public().$patch({
          width: innerWidth,
          height: innerHeight
        });
        $Store.Public().updateGrid();
        this.changeRem();
      });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

.index {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  
  .container {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="less" rel="stylesheet/less">
@import '@node_modules/ant-design-vue/dist/antd.css';

@import '@resource/css/_global.less';
</style>